import { Platform } from '../../constants';
import { Entity } from '../models.interface';
import { TranslationValue } from './translation-value.interface.';

export interface Translation extends Entity {
  group: string;
  subGroup: string;
  keyValue: string;
  platform: Platform;
  dynamicTranslation: boolean;
  translationValues: Array<TranslationValue>;
}

export class EmptyTranslation implements Translation {
  id = null;
  group = null;
  subGroup = null;
  keyValue = null;
  platform = Platform.BOTH;
  dynamicTranslation = true;
  translationValues = [];
}
